/**
 * Removed migrations: finished one-offs whose code was deleted. Read only; sf-api refuses to start
 * them, so the only action is their history.
 */
import { Button, Table, Typography } from 'antd';
import type { RemovedMigration } from '../api/migrationsClient';
import { LastRunCell, MigrationName, MigrationStatusTag } from './MigrationsTable';

const { Text } = Typography;

export interface RemovedMigrationsTableProps {
  removed: RemovedMigration[];
  onOpen: (m: RemovedMigration) => void;
}

export const RemovedMigrationsTable: React.FC<RemovedMigrationsTableProps> = ({
  removed,
  onOpen,
}) => (
  <section aria-label="Removed migrations">
    <Text type="secondary">
      Finished one-off migrations whose code has been deleted. Their run history is kept here.
    </Text>
    <Table<RemovedMigration>
      style={{ marginTop: 12 }}
      rowKey="id"
      size="small"
      dataSource={removed}
      // Not paged on purpose, like the main list: one row per migration whose code was deleted, so
      // it only grows when a pull request deletes a script (a handful a month), never with data.
      pagination={false}
      onRow={(m) => ({ onClick: () => onOpen(m), style: { cursor: 'pointer' } })}
      columns={[
        {
          title: 'Migration',
          key: 'migration',
          render: (_, m) => <MigrationName id={m.id} ticket={m.ticket} />,
        },
        {
          title: 'What it did',
          key: 'description',
          render: (_, m) => m.description ?? '-',
        },
        {
          title: 'Status',
          key: 'status',
          render: (_, m) => <MigrationStatusTag status={m.status} />,
        },
        {
          title: 'Last real run',
          key: 'last',
          render: (_, m) => <LastRunCell run={m.lastApply} />,
        },
        {
          title: 'Actions',
          key: 'actions',
          render: (_, m) => (
            <Button
              size="small"
              type="link"
              onClick={(e) => {
                e.stopPropagation();
                onOpen(m);
              }}
            >
              History
            </Button>
          ),
        },
      ]}
    />
  </section>
);
